var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretIcon = function SvgCaretIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.011 8.022 2.74 3.75a.975.975 0 0 0-1.38 1.38l4.688 4.687a1.342 1.342 0 0 0 1.929 0l4.687-4.688a.975.975 0 1 0-1.379-1.379L7.011 8.022Z",
    fill: "inherit"
  })));
};
export default SvgCaretIcon;